import { createSelector } from 'reselect';
import { hasCameraAccess, hasMicrophoneAccess } from '../../devices/selectors';
export const getLocalMediaState = (state) => state.localMedia;
const hasVideoUI = (state) => getLocalMediaState(state).hasVideo;
const hasAudioUI = (state) => getLocalMediaState(state).hasAudio;
export const hasVideo = createSelector(hasCameraAccess, hasVideoUI, (hasCameraAccess, hasVideoUI) => hasCameraAccess && hasVideoUI);
export const hasAudio = createSelector(hasMicrophoneAccess, hasAudioUI, (hasMicrophoneAccess, hasAudioUI) => hasMicrophoneAccess && hasAudioUI);
export const mediaAvailability = createSelector(hasVideo, hasAudio, (hasVideo, hasAudio) => ({ hasVideo, hasAudio }));
